import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboard, History, Settings, CreditCard, ScrollText, HelpCircle, Receipt } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { TopNavbar } from './TopNavbar';

const DashboardLayout = ({ children }) => {
    const [darkMode, setDarkMode] = useState(false);
    const { signOut, user } = useAuth();
    const location = useLocation();

    const navigation = [
        {
            name: 'Dashboard',
            href: '/',
            icon: LayoutDashboard,
            current: location.pathname === '/'
        },
        {
            name: 'Analysis History',
            href: '/history',
            icon: History,
            current: location.pathname === '/history'
        },
        {
            name: 'Custom Types',
            href: '/custom-analysis',
            icon: Settings,
            current: location.pathname === '/custom-analysis'
        },
        {
            name: 'Get More Credits',
            href: '/buy-credits',
            icon: CreditCard,
            current: location.pathname === '/buy-credits'
        },
        {
            name: 'Credit Transactions',
            href: '/credit-transactions',
            icon: Receipt,
            current: location.pathname === '/credit-transactions'
        },
        {
            name: 'Invoices',
            href: '/invoices',
            icon: ScrollText,
            current: location.pathname === '/invoices'
        },
        {
            name: 'Help & Support',
            href: '/support',
            icon: HelpCircle,
            current: location.pathname === '/support'
        },
    ];

    const handleSignOut = async () => {
        try {
            await signOut();
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    return (
        <div className={`min-h-screen ${darkMode ? 'dark' : ''}`}>
            <Sidebar navigation={navigation} />
            <div className="md:pl-64">  {/* Add padding-left equal to sidebar width */}
                <TopNavbar
                    navigation={navigation}
                    darkMode={darkMode}
                    setDarkMode={setDarkMode}
                    user={user}
                    handleSignOut={handleSignOut}
                />
                <div className="pt-16 min-h-screen bg-gray-100 dark:bg-gray-900"> {/* Add padding-top equal to navbar height */}
                    <main className="py-6 px-4 sm:px-6 lg:px-8">
                        {children}
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;